import { render, staticRenderFns } from "./MealCard.vue?vue&type=template&id=2dd5ccdc&scoped=true"
import script from "./MealCard.vue?vue&type=script&lang=js"
export * from "./MealCard.vue?vue&type=script&lang=js"
import style0 from "./MealCard.vue?vue&type=style&index=0&id=2dd5ccdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd5ccdc",
  null
  
)

export default component.exports